import type { RenderOptions } from '@hf/render-core/types';
import type { Settings } from '../ui-model/types';

/** Renderer options that follow the player's settings. */
export const renderOptionsFrom = (s: Settings): RenderOptions => ({
  screenShake: s.screenShake,
  crt: s.crt,
  reducedMotion: s.reducedMotion,
  debug: s.showStats,
});
